export default __webpack_public_path__ + "static/media/unknown-file.c81b9fb7.svg";